<template>
  <div id="app">
    <div id="eprop">
      <Header title="Proposal Generator" />
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="facet">
              <form id="eproposal_frm">
                <div id="contact_info">
                  <div class="form-group">
                    <label>Name</label>
                    <input class="form-control" id="contact_name" name="contact_name" v-model="contact_name" />
                  </div>
                  <div class="form-group">
                    <label>Title</label>
                    <input class="form-control" id="contact_title" name="contact_title" v-model="contact_title" />
                  </div>
                  <div class="form-group">
                    <label>Email</label>
                    <input class="form-control" id="contact_email" name="contact_email" v-model="contact_email" />
                  </div>
                  <div class="form-group">
                    <label>Phone</label>
                    <input class="form-control" id="contact_phone" name="contact_phone" v-model="contact_phone" />
                  </div>
                  <div class="ep_message">
                    * The provided contact info appears in the footer of the
                    template. We may also use this info to email you a copy of
                    the template
                  </div>
                </div>
                <hr />
                <!-- -------------------- Advertising Support  ------------------------------>
                <input type="checkbox" id="checkbox" v-model="show_as" />
                <label for="checkbox"> Show Advertising Section </label>
                <div v-if="show_as">
                  <div class="advertising-support">Advertising Support</div>
                  <hr />
                  <div>
                    <input
                      type="radio"
                      id="local"
                      value="local"
                      name="as_region"
                      v-model="as_picked"
                      @change="loadASPrice"
                    />
                    <label for="local">Local</label>

                    <input
                      type="radio"
                      id="regional"
                      name="as_region"
                      value="regional"
                      v-model="as_picked"
                      @change="loadASPrice"
                    />
                    <label for="regional">Regional</label>

                    <input
                      type="radio"
                      id="national"
                      name="as_region"
                      value="national"
                      v-model="as_picked"
                      @change="loadASPrice"
                    />
                    <label for="national">National</label>
                  </div>

                  <hr />

                  <div class="form-group">
                    <label>RCI’s TalentLocator Showcase</label>
                    <input class="form-control" v-model="as_tl_showcase" />
                  </div>

                  <div class="add-on">Add ons</div>
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>Texts</label>
                      <input class="form-control" v-model="as_addon_txt" />
                    </div>
                    <div class="form-group col-lg-6">
                      <label>Calls</label>
                      <input class="form-control" v-model="as_addon_call" />
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>PremierPost</label>
                      <input class="form-control" v-model="as_premier_post" />
                    </div>
                    <div class="form-group col-lg-6">
                      <label>PerfectPost</label>
                      <input class="form-control" v-model="as_perfect_post" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>Video PremierPost</label>
                      <input
                        class="form-control"
                        v-model="as_video_premier_post"
                      />
                    </div>
                    <div class="form-group col-lg-6">
                      <label>Video PerfectPost</label>
                      <input
                        class="form-control"
                        v-model="as_video_perfect_post"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>PerfectAssist</label>
                      <input
                        class="form-control"
                        v-model="as_addon_perfect_assist"
                      />
                    </div>
                  </div>
                </div>
                <hr />

                <!-- -------------------- Sourcing  ------------------------------>
                <input type="checkbox" id="show_ss_cb" v-model="show_ss" />
                <label for="show_ss_cb"> Show Sourcing Section </label>
                <div v-if="show_ss">
                  <div class="sourcing-support">Sourcing Support</div>
                  <hr />
                  <div>
                    <input
                      type="radio"
                      id="local"
                      value="local"
                      name="ss_region"
                      v-model="ss_picked"
                      @change="loadSSPrice"
                    />
                    <label for="local">Local</label>

                    <input
                      type="radio"
                      id="regional"
                      name="ss_region"
                      value="regional"
                      v-model="ss_picked"
                      @change="loadSSPrice"
                    />
                    <label for="regional">Regional</label>

                    <input
                      type="radio"
                      id="national"
                      name="ss_region"
                      value="national"
                      v-model="ss_picked"
                      @change="loadSSPrice"
                    />
                    <label for="national">National</label>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="form-group col-lg-10">
                      <label>RCI’s TalentLocator Pipeline</label>
                      <input
                        class="form-control col-lg-4"
                        v-model="ss_tl_pipeline"
                        placeholder=""
                      />
                    </div>
                  </div>
                </div>
                <!-- -------------------- Recruiting  ------------------------------>
                <hr />
                <input type="checkbox" id="show_rs_cb" v-model="show_rs" />
                <label for="show_rs_cb"> Show Recruiting Section </label>
                <div v-if="show_rs">
                  <div class="recruiting-support">Recruiting Support</div>
                  <hr />
                  <div>
                    <input
                      type="radio"
                      id="local"
                      value="local"
                      name="rs_region"
                      v-model="rs_picked"
                      @change="loadRSPrice"
                    />
                    <label for="local">Local</label>

                    <input
                      type="radio"
                      id="regional"
                      name="rs_region"
                      value="regional"
                      v-model="rs_picked"
                      @change="loadRSPrice"
                    />
                    <label for="regional">Regional</label>

                    <input
                      type="radio"
                      id="national"
                      name="rs_region"
                      value="national"
                      v-model="rs_picked"
                      @change="loadRSPrice"
                    />
                    <label for="national">National</label>
                  </div>
                  <hr />
                  <div class="form-group">
                    <label>TL Recruit</label>
                    <input
                      class="form-control"
                      v-model="rs_tl_recruit"
                      placeholder=""
                    />
                  </div>
                  <hr />
                  <div class="form-group">
                    <label>Just-In-Time RPO </label>
                    <input
                      class="form-control"
                      v-model="rs_jit_rpo"
                      placeholder=""
                    />
                  </div>

                    <div class="form-group">
                      <label>Project-based RPO</label>
                      <input
                        class="form-control"
                        v-model="rs_pb_rpo"
                        placeholder=""
                      />
                    </div>

                    <div class="form-group">
                      <label>Full-Life RPO</label>
                      <input
                        class="form-control"
                        v-model="rs_fl_rpo"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group">
                      <label>Contained Search</label>
                      <input
                        class="form-control"
                        v-model="rs_container_search"
                        placeholder=""
                      />
                    </div>

                    <div class="form-group">
                      <label>Retained Search</label>
                      <input
                        class="form-control"
                        v-model="rs_retained_search"
                        placeholder=""
                      />
                    </div>

                    <div class="form-group">
                      <label>Contingency Search</label>
                      <input
                        class="form-control"
                        v-model="rs_contingency_search"
                        placeholder=""
                      />
                    </div>
                    <div>
                  </div>
                </div>
                <!-- -------------------- Buttons area ------------------------------>
                <div class="ep_message">
                  * items with $0 as amount are ususally hidden
                </div>
                <hr />
                <textarea
                  class="form-control"
                  id="GeneratedProposal"
                  name="GeneratedProposal"
                  rows="10"
                  style="display: none"
                ></textarea>

                <button
                  type="button"
                  id="genEmail"
                  name='genEmail'
                  class="btn btn-primary btn-ep">
                  Email me the Generated Proposal
                </button>
                <br /><br />
              </form>
            </div>
          </div>

          <div class="col-md-8">
            <Eprop
              :contact_name="contact_name"
              :contact_title="contact_title"
              :contact_email="contact_email"
              :contact_phone="contact_phone"
              :as_tl_showcase="as_tl_showcase"
              :as_addon_txt="as_addon_txt"
              :as_addon_call="as_addon_call"
              :as_premier_post="as_premier_post"
              :as_perfect_post="as_perfect_post"
              :as_video_premier_post="as_video_premier_post"
              :as_video_perfect_post="as_video_perfect_post"
              :as_addon_perfect_assist="as_addon_perfect_assist"
              :ss_tl_pipeline="ss_tl_pipeline"
              :rs_tl_recruit="rs_tl_recruit"
              :rs_jit_rpo="rs_jit_rpo"
              :rs_pb_rpo="rs_pb_rpo"
              :rs_fl_rpo="rs_fl_rpo"
              :rs_container_search="rs_container_search"
              :rs_retained_search="rs_retained_search"
              :rs_contingency_search="rs_contingency_search"
              :as_picked="as_picked"
              :ss_picked="ss_picked"
              :rs_picked="rs_picked"
              :show_as="show_as"
              :show_ss="show_ss"
              :show_rs="show_rs"
            ></Eprop>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*  eslint-disable  */
import { required, minLength, between } from "vuelidate/lib/validators";
import Header from "./components/Header";
import Eprop from "./components/Eprop";

export default {
  name: "App",
  components: {
    Header,
    Eprop,
  },
  data: function () {
    var objDefault = {
      contact_name: "Mike Moore",
      contact_title: "CEO",
      contact_email: "mmoore@rciars.com",
      contact_phone: "561.686.6800",
      as_tl_showcase: 0,
      as_addon_txt: 0,
      as_addon_call: 0,
      as_premier_post: 0,
      as_perfect_post: 0,
      as_video_premier_post: 0,
      as_video_perfect_post: 0,
      as_addon_perfect_assist: 0,
      ss_tl_pipeline: 0,
      rs_tl_recruit: 7995,
      rs_jit_rpo: "",
      rs_pb_rpo: "",
      rs_fl_rpo: "",
      rs_container_search: "",
      rs_retained_search: "",
      rs_contingency_search: "",
      as_picked: "local",
      ss_picked: "local",
      rs_picked: "local",
      show_as: false,
      show_ss: false,
      show_rs: false,
    };
    return objDefault;
  },

  validations: {
    as_tl_showcase: {
      required,
      between: between(20, 30),
    },
  },

  computed: {},

  methods: {
    loadASPrice: function () {
      if (this.as_picked == "local") {
        this.as_tl_showcase = 2995;
        this.as_addon_txt = 995;
        this.as_addon_call = 1995;
      }
      if (this.as_picked == "regional") {
        this.as_tl_showcase = 3995;
        this.as_addon_txt = 1995;
        this.as_addon_call = 3995;
      }
      if (this.as_picked == "national") {
        this.as_tl_showcase = 6995;
        this.as_addon_txt = 4995;
        this.as_addon_call = 7995;
      }
    },
    loadSSPrice: function () {
      if (this.ss_picked == "local") {
        this.ss_tl_pipeline = 3995;
      }
      if (this.ss_picked == "regional") {
        this.ss_tl_pipeline = 5995;
      }
      if (this.ss_picked == "national") {
        this.ss_tl_pipeline = 8995;
      }
    },
    loadRSPrice: function () {
      if (this.rs_picked == "local") {
        this.rs_tl_recruit = 7995;
      }
      if (this.rs_picked == "regional") {
        this.rs_tl_recruit = 0;
      }
      if (this.rs_picked == "national") {
        this.rs_tl_recruit = 0;
      }
    },
    resetFrm: function () {
      this.rs_tl_recruit = 0;
    },
    onCopy: function (e) {
      alert("You just copied: " + e.text);
    },
    onError: function (e) {
      alert("Failed to copy texts");
    },
    emailProposal: function () {
      alert("This functionality is not yet enabled");
    },
  },

  async created() {
    this.loadASPrice();
    this.loadSSPrice();
    this.loadRSPrice();
  },
};
</script>


<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.facet {
  background-color: #f5f5f5;
  padding: 30px;
}
.advertising-support {
  font-weight: bold;
  font-size: 18px;
  text-transform: uppercase;
  background-color: rgb(0, 101, 164);
  color: white;
  padding: 15px;
}
.sourcing-support {
  font-weight: bold;
  font-size: 18px;
  text-transform: uppercase;
  background-color: #00929f;
  color: white;
  text-align: center;
  padding: 15px;
}
.recruiting-support {
  font-weight: bold;
  font-size: 18px;
  text-transform: uppercase;
  background-color: #6cb33f;
  color: white;
  text-align: center;
  padding: 15px;
}
.add-on {
  font-weight: bold;
  color: rgb(0, 101, 164);
  text-transform: capitalize;
  font-size: 12px;
  text-decoration: underline;
  padding-top: 5px;
  padding-bottom: 5px;
}
label {
  font-size: 14px;
}
#contact_info {
  border: 2px solid #00929f;
  border-radius: 10px;
  padding: 15px;
  font-weight: bold;
}
.btn-ep {
  color: #fff;
  background-color: #00929f !important;
  border-color: #00929f !important;
}
.ep_message {
  font-size: 12px;
  font-weight: normal;
  padding: 15px;
  font-style: italic;
}
</style>


// WEBPACK FOOTER //
// src/App.vue